// extracted by mini-css-extract-plugin
module.exports = {"footer":"B78vxBKYoB+1LwlMkL2dhA==","declaration":"_6kvH0pI-x0Kul6D0K66gNA=="};